
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/email",
      function () {
        return require("private-next-pages/android/email/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/email"])
      });
    }
  